import React from 'react';
import {Button} from "@mui/material";

// Shared form submit button.
// Always a positive/confirm action -> green, contained by default,
// and shows an outlined look on hover (white bg + green border/text).
const SubmitButton = ({val,size,mainColor,subColor,style,mb}) => {
    return (
        <Button
            size={size}
            sx={{
                background: '#27AE60',
                border: '1px solid #27AE60',
                color: '#fff',
                textTransform: "capitalize",
                boxShadow: 'none',
                "&:hover": {
                    background: '#219653',
                    color: '#fff',
                    border: '1px solid #27AE60',
                    boxShadow: 'none',
                },
                '@media (max-width:319px)':{ marginBottom:mb }
            }}
            variant={'contained'}
            type={'submit'}
            style={style}
        >
            {val}
        </Button>
    );
};

export default SubmitButton;
